import useFeatureFlag from '../useFeatureFlag';

export function useV2ConferenceEmails() {
  return useFeatureFlag('APP4083_V2_Conference_Emails', false);
}
